import { Loading } from '@library/components/Loading';
import { PageBody } from '@library/components/layout/PageBody';
import { UnselttlementsHeader } from '@bo-components/unsettlements/unsettlementsList/UnsettlementsHeader';
import { UnsettlementsTable } from '@bo-components/unsettlements/unsettlementsList/UnsettlementsTable';
import { useUnsettlementsActions } from '@bo-hooks/unsettlements/useUnsettlementsActions';

export const UnsettlementsList = () => {
  const {
    currentPage,
    data: unsettlementsActionsData = [],
    handleCurrentPageChange,
    totalPages,
    isFetching: isUnsettlementsActionsFetching
  } = useUnsettlementsActions();

  if (isUnsettlementsActionsFetching) {
    return <Loading loadingMessage="Loading Unsettlements" />;
  }
  return (
    <>
      <UnselttlementsHeader isHomePage />
      <PageBody>
        <UnsettlementsTable
          currentPage={currentPage}
          handleCurrentPageChange={handleCurrentPageChange}
          totalPages={totalPages}
          unsettlementsData={unsettlementsActionsData}
        />
      </PageBody>
    </>
  );
};
